export default __webpack_public_path__ + "static/media/149.d30a25ad.jpg";